import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS, ROL } from "../configuration/globalConstants";
import transformToOption from "../utils/transformToOptionSelect";
import { getStores } from "../services/viewingMotionsServices";
import { useSessionStore } from "../store/sessionStore";

export function useStores(validateRol = false) {
  const { rol } = useSessionStore()
  const stores = useQuery({
    queryKey: ["stores"],
    queryFn: () => getStores(),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !validateRol || (validateRol && rol.id === ROL.SUPERADMIN), // Placeholder for role validation logic
  });

  return {
    stores: stores.data || null,
    storeOptions: stores.data ? transformToOption(stores.data) : null,
    isLoadingStores: stores.isLoading,
  };
}
